module.exports = __webpack_public_path__ + "static/media/bg10.27577214.png";